// extracted by mini-css-extract-plugin
export default {"legal":"clqGu","sub-section":"vtfJq"};